import React, { useEffect, useState } from 'react'
import { SelectControl } from '@wordpress/components';

function MaintenancePage(props) {

    const [ maintenancePage, setPage ] = useState( props.page )
    const [ maintenancePages, setPages ] = useState([])
    useEffect(() => {
        async function loadPage() {
            const response = await fetch('/wp-json/wp/v2/pages');
            if(!response.ok) {
                return;
            }
    
            const pageOpts = await response.json();
            const pages = [];
            pageOpts.map((page,index) => {
                pages.push({label:page.title.rendered,value:page.id})
            })
            setPages(pages)
        }
    
        loadPage();
        
    }, [])

    let opts = [{label:"",value:0}];
    maintenancePages.map((page, index) => {
        opts.push(page)
    })

    
    const handleChange = ( new_page ) => props.handlePageChange(new_page)
    
    return(
    
        <>
            <SelectControl
                label="Maintenance Page"
                value={ props.page }
                options={ opts }
                onChange={ ( newPage ) => {
                    setPage( newPage ); 
                    handleChange( newPage )
                }}
                className="dbd-select-sm"
            />
            
        </>
    );
}
export default MaintenancePage